import { useI18n } from '../../i18n/i18n-context';
import { PromoPlayer } from '../promo/PromoPlayer';
import poster from './desktop-promo-poster.jpg';

/** An optional app overview follows the platform downloads. */
export function DesktopPromo() {
  const { t } = useI18n();
  return (
    <div className="desktop-promo">
      <PromoPlayer
        src="/media/desktop-promo-v17-web.mp4"
        sources={[
          {
            src: '/media/desktop-promo-v17-web.webm',
            type: 'video/webm; codecs="vp09.02.40.10, opus"',
          },
          {
            src: '/media/desktop-promo-v17-web.mp4',
            type: 'video/mp4; codecs="avc1.640033, mp4a.40.2"',
          },
        ]}
        poster={poster}
        label={t.downloads.heading}
        watchLabel={`${t.promo.watch} · 40 s`}
        initialDuration={40}
        preload="none"
      />
    </div>
  );
}
